module.exports = __webpack_public_path__ + "img/text.2cc48c7a.png";